import axios from "axios";
import { useCallback, useEffect } from "react";
import { Form, Spinner } from "react-bootstrap";
import RycoViewport from "../../components/Common/RycoViewport";
import useTrait from "../../components/Common/syncUpdateState";
import GridVideos from "../../components/RycoTv/girdVideos";
import Footer from "../../components/_App/Footer";
import Header from "../../components/_App/Header";
import apiClient from "../../data/apiClient";
import { FOOTER_QUERY } from "../../data/pageQuery";

const RycoTV = ({
  id,
  seo,
  footer,
  menu,
  results,
  channelDetails,
  mainVideo,
}) => {
  const lists = useTrait([]);
  const masterVideoId = useTrait();
  const selectedList = useTrait([]);
  const active = useTrait(0);
  const tagName = useTrait("");
  const title = useTrait();
  const selectItem = useTrait();
  const isLoading = useTrait(false);
  const { width } = RycoViewport();
  const breakPoint = 620;
  var tags = [];

  const url = `/api/youtubePlayer`;

  const backCacheData = useCallback(async () => {
    isLoading.set(true);
    const response = await axios.get(url, {});
    if (response.status === 200) {
      await lists.set(
        response.data.detailsPlaylist.sort((a, b) =>
          a.snippet?.title > b.snippet?.title ? 1 : -1
        )
      );
      await masterVideoId.set(response.data.mainVideo);
      //console.log("_masterVideo",response.data);
      isLoading.set(false);
    } else {
      // console.log(response);
      throw new Error(response.detailsPlaylist);
    }
  }, []);

  useEffect(() => {
    backCacheData();
  }, [backCacheData]);
  const updateSelectedList = useCallback(() => {
    if (lists.get().length > 0) {
      var searchList = lists.get().find((item) => item.etag == tagName.get());
      selectedList.set(searchList?.list[0]);
    }
  }, [tagName]);
  useEffect(() => {
    updateSelectedList();
  }, [tagName]);

  const filteredtags = lists.get()?.map((item) => {
    const { etag, snippet, id } = item;

    tags.push({ etag, id, snippet });
    if (tags.length > 0 && tagName.get() == "") {
      active.set(tags[0]?.etag);
      tagName.set(tags[0]?.etag);
      title.set(tags[0]?.snippet?.title);
    }
  });
  const HandelSlecetValue = (element) => {
    tags?.map((elem, idx) => {
      if (elem.etag === element) {
        // console.log("_elem", element);
        selectItem.set(element);
        active.set(elem.etag);
        tagName.set(elem.etag);
        title.set(elem.snippet?.title);
        return;
      }
    });
  };

  const HandleActive = (element) => {
    active.set(element.etag);
    tagName.set(element.etag);
    title.set(element.snippet?.title);
  };

  return (
    <>
      <Header {...menu} />
      <div className='w-100 d-flex bg-light py-md-4 py-3'>
        <nav style={{}} className='container' aria-label='breadcrumb'>
          <ol className='breadcrumb mb-0'>
            <li className='breadcrumb-item'>
              <a href='#'>Home</a>
            </li>
            <li className='breadcrumb-item d-block d-md-none'>
              <a href='#'>...</a>
            </li>
            <li className='breadcrumb-item'>
              <a href='#'>Ryco TV</a>
            </li>
            <li className='breadcrumb-item active' aria-current='page'>
              Youtube Videos
            </li>
          </ol>
        </nav>
      </div>
      <div className='page-wrapper flex-grow-0'>
        {/* <BreadcrumbComponent {...data}></BreadcrumbComponent> */}
        <div>
          {/* <PageHeadingComponent {...data}></PageHeadingComponent>*/}
          <div className='container p-lg-0'>
            <div className='row'>
              <h1 className='fs-2 fw-bold lh-1 mt-5 js-video-category'>
                Ryco TV
              </h1>
              <div className='mt-4 mb-4'>
                <iframe
                  frameBorder='0'
                  style={{ border: 0 }}
                  title='Ryco Videos'
                  width='100%'
                  height={width > breakPoint ? "750px" : "250px"}
                  src={"https://www.youtube.com/embed/" + mainVideo}
                  allowFullScreen
                  allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                ></iframe>
              </div>
              {isLoading.get() && (
                <Spinner
                  as='span'
                  animation='border'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              )}
              {!isLoading.get() && (
                <>
                  <div className='my-2'>
                    <h5 className='fs-2 fw-bold lh-1'>Play Lists </h5>

                    {width > breakPoint &&
                      tags?.map(
                        (
                          elem,
                          idx // .slice(1)
                        ) => (
                          <button
                            onClick={() => HandleActive(elem)}
                            key={"tag_" + elem.etag}
                            className='btn btn-outline btn-sm fs-sm rounded-pill m-1'
                            style={{
                              background:
                                active.get() === elem.etag
                                  ? "rgb(205 26 26)"
                                  : "none",
                              color:
                                active.get() === elem.etag
                                  ? "rgb(236 243 249)"
                                  : "#212529",
                            }}
                          >
                            {elem?.snippet?.title}
                          </button>
                        )
                      )}
                    {width < breakPoint && (
                      <div>
                        <Form.Select
                          value={selectItem.get()}
                          onChange={(e) => HandelSlecetValue(e.target.value)}
                          size='sm'
                        >
                          {tags?.map((elem, idx) => {
                            return (
                              <option
                                key={"tag_" + elem.etag}
                                value={elem.etag}
                              >
                                {elem?.snippet?.title}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
            <br />
            <div>
              <GridVideos
                videos={selectedList.get()}
                activeTag={tagName.get()}
                title={title.get()}
              />
            </div>
          </div>
        </div>
      </div>
      <Footer {...footer} />
    </>
  );
};
export async function getStaticProps() {
  const { data } = await(await apiClient()).query({
    query: FOOTER_QUERY,
    variables: {},
    fetchPolicy: "cache-first",
  });

  const {
    queryPagesContents: pageDataList,
    queryFooterContents: footerContents,
    queryMenuContents: menuContents,
  } = data;

  const footerContent =
    footerContents[0] != null ? footerContents[0].flatData : [];
  const menuContent = menuContents[0] != null ? menuContents[0].flatData : [];

  const videoUrl = `${process.env.CMS_API_URL}api/content/${process.env.CMS_PROJECT}/ryco-tv/`; //"https://rycocms.azurewebsites.net/api/content/rycodev/ryco-tv/";
  const resp = await fetch(videoUrl);
  const videoObj = await resp?.json();
  const mainVideo = videoObj?.items[0]?.data?.mainYoutubeVideoId.iv;

  return {
    props: {
      footer: footerContent,
      menu: menuContent,
      mainVideo: mainVideo,
      seo: {
        title: "Ryco videos - Ryco filters",
        metadata:
          "Want to know how to service your filters? Or how our tools can help you? Ryco TV offers online videos and tips to make car and vehicle maintenance easy.",
        keywords: "Ryco TV, Ryco Videos",
        socialTitle:
          "Want to know how to service your filters? Or how our tools can help you? Ryco TV offers online videos and tips to make car and vehicle maintenance easy.",
        url: "/-/ryco-tv",
        isNzOnly: false,
      },
    },
    revalidate: 30 * 60,
  };
}

export default RycoTV;
